import React, { useState } from "react"
import StaticSelector from "components/Atoms/StaticSelector"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { BULK_UPDATE_VEHICLE_STATUS } from "graphql/vehicle/vehicle.mutations.gql"
import { useSelector } from "react-redux"
import StringInput from "components/Atoms/StringInput"
import { VEHICLE_STATUSES } from "data/static.items"
import AppToaster from "utils/AppToaster"

function UpdateStatus() {
  const [status, setStatus] = useState(null)
  const [remark, setRemark] = useState("")
  const vehicles = useSelector(state => state.selector.vehicles.selected)

  return (
    <>
      <StaticSelector
        label="Status"
        className="w-1/4 mt-3"
        value={status}
        items={VEHICLE_STATUSES}
        onChange={(_, status) => setStatus(status)}
      />
      <StringInput
        label="Remark"
        className="w-3/4 mt-3"
        big={false}
        value={remark}
        onChange={(_, value) => setRemark(value)}
      />
      <ButtonMutation
        onCompleted={data => {
          const vehicles = data?.bulkUpdateVehicleStatus?.vehicles
          AppToaster.show({
            intent: "success",
            icon: "endorsed",
            message: `Status changed to ${vehicles?.[0]?.status} for ${
              vehicles?.length ?? 0
            } Vehicles`,
          })
        }}
        onError={err => {
          AppToaster.show({
            intent: "danger",
            icon: "cross",
            message: "Unable to change the status of the selected vehicles",
          })
        }}
        icon="confirm"
        text="Update Status"
        mutation={BULK_UPDATE_VEHICLE_STATUS}
        variables={{
          vehicles: Object.keys(vehicles),
          status: status?.id,
        }}
      />
    </>
  )
}
export default UpdateStatus
